export default __webpack_public_path__ + "static/media/video-play.aec0eaaa.png";